export const EditAnswerButton = ({ onPress, disabled }) => {
  return (
    <button
      style={{ background: "transparent", border: "none" }}
      onClick={onPress}
      disabled={disabled}
    >
      <img src="/icons/chat-edit.svg" alt="Edit" />
    </button>
  );
};
